import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { checkCNP} from "Utils";
import Button from "@mui/material/Button";
import { TextFieldMask } from "TemplateCerere";
import { ArrowRight } from "@mui/icons-material";
import { IconsSvg } from "TemplateCerere";
import TextField from "@mui/material/TextField";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const RegisterReevaluarePF = (props) => {
  const navigateUrl = useNavigate();

  const { cimpuri, save, updateValue } = props.store;
  const { getField } = props.common;
  const [cnp, setCNP] = useState({ value: null, error: null });
  const [idRom, setIdRom] = useState(true);
  const [tipActiune, setTipActiune] = useState({ value: null, error: null });

  const [acordDownloaded, setAcordDownloaded] = useState(true);

  const [unitate, setUnitate] = useState("");

  useEffect(() => {

    setUnitate(getField(-99)?.Valoare);
    setTipActiune(getField(-98)?.Valoare);
  }, [cimpuri]);

  useEffect(() => {
    /*La modificare  resetez eroarea de la CNP*/
    setCNP({ value: cnp.value, error: null });
  }, [idRom]);

  var toolbarCss = "paper-toolbar";

  const validare = () => {
    const { errors } = props.main;
    var errorMsgs = [];
    var msg = "";
    if (idRom) {
      if (!checkCNP(cnp?.value)) {
        msg = "[OPF2]Campul CNP este incorect!";
        errorMsgs.push(msg);
        setCNP({ value: cnp.value, error: errors.processMsg(msg) });
      }
    } else {
      if (!cnp.value || cnp.value.length < 7) {
        msg = "[OPF2]Campul CNP este incorect!";
        errorMsgs.push(msg);
        setCNP({ value: cnp.value, error: errors.processMsg(msg) });
      }
    }
    return errorMsgs;
  };
  const handleNew = () => {
    var errorMsgs = validare();
    if (errorMsgs.length !== 0) {
      return;
    }
    updateValue(getField(2), cnp.value);
    updateValue(getField(11), idRom ? 150 : null);
    save(navigateUrl);
  };

  return (
    <div className={toolbarCss}>
      <CssBaseline />
      <IconsSvg icon="IllustrationHello" />
      <p className="page-title">Buna,</p>
      <p className="normal-text">
        Pentru a incepe actiunea selectata este important sa completezi
        campurile de mai jos:
      </p>
      <div className="form">
        <TextField
          variant="outlined"
          margin="normal"
          disabled
          id="unitate"
          label="Unitatea teritoriala"
          value={unitate ?? ""}
          className="login-txt"
          size="small"
        />
        <TextField
          variant="outlined"
          margin="normal"
          disabled
          fullWidth
          id="actiune"
          label="Tip actiune"
          value={tipActiune}
          className="login-txt"
          size="small"
        />
        <TextField
          variant="outlined"
          margin="normal"
          disabled
          fullWidth
          id="client"
          label="Tipul de client"
          value="Persoana fizica"
          className="login-txt"
          size="small"
        />

        <div className="form switch-group">
          <div className="label">
            Persoana are un act de identitate emis in Romania
          </div>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                width="100px"
                checked={idRom}
                onChange={(prop) => {
                  setIdRom(prop.target.checked);
                }}
              />
            }
            label={idRom ? "Da" : "Nu"}
            labelPlacement="top"
          />
        </div>
        {idRom && (
          <TextFieldMask
            id="cnp"
            label="CNP *"
            defaultValue={cnp?.value ?? ""}
            className="login-pwd"
            variant="outlined"
            onBlur={(prop) => setCNP({ value: prop.target.value, error: null })}
            mask="0000000000000"
            error={!!cnp.error}
            helperText={cnp.error}
            type="tel"
          />
        )}
        {!idRom && (
          <TextField
            id="dcnp"
            label="NIF/Serie si nr. act de identitate/Cod client *"
            value={cnp?.value ?? ""}
            onChange={(event) => {
              setCNP({
                value: event.target.value?.toUpperCase(),
                error: null,
              });
            }}
            className="login-pwd"
            variant="outlined"
            error={!!cnp.error}
            helperText={cnp.error}
          />
        )}
        
      </div>
      <p></p>
      <Button
        variant="contained"
        color="primary"
        className="login-btn"
        onClick={handleNew}
        endIcon={<ArrowRight fontSize="large" />}
        disabled={!acordDownloaded}
      >
        Continua
      </Button>
    </div>
  );
};
export default inject((stores) => ({
  store: stores.cerereNouaStore,
  main: stores.mainStore,
  common: stores.commonStore,
}))(observer(RegisterReevaluarePF));
